/* global appdata */
import 'modaal/dist/js/modaal'
import map from 'lodash/map'
import size from 'lodash/size'
import '../util/steps'


export default {
    stepsLoad() {
        const app = this
        const stepsall = $('#checkout-steps').steps({
            startAt: $('#checkout-steps').hasClass('logged') ? 1 : 0,
        });
        const steps_api = stepsall.data('plugin_Steps');

        $(document.body).on('click', '.guest-btn', function(e){
            e.preventDefault()
            steps_api.next();
            $( document.body ).trigger( 'update_checkout' );
        })
        $(document.body).on('click', '.shipping-btn', function(e){
            e.preventDefault()
            window.scrollTo(0, 0);
            steps_api.next();
            $( document.body ).trigger( 'update_checkout' );
        })
        $(document).ready(function() {
          $(window).keydown(function(event){
            if( (event.keyCode == 13) ) {
              event.preventDefault();
              return false;
            }
          });
        });
    },
    modalLogin() {
        $('.showlogin').modaal();
        $(document.body).on('click','.showloginerror',function(e){
            e.preventDefault()
            $('.showlogin').modaal('open')
        })
        $(document.body).on('keypress', 'input#billing_email' ,function (event) {
            var $parent           = $(this).closest( '.input-wrapper' );
            var pattern = new RegExp(/^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[0-9a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i); // eslint-disable-line max-len
            /* eslint-enable */
            if ( ! pattern.test( $(this).val()  ) ) {
                $parent.removeClass( 'woocommerce-validated' ).addClass( 'woocommerce-invalid woocommerce-invalid-email' );
                if($(this).attr('name') == 'billing_email'){
                  $('.guest-btn').addClass('disabled')
                  $('.guest-btn').prop('disabled', 'disabled')
                }
            } else {
                if($(this).attr('name') == 'billing_email'){
                  $('.guest-btn').removeClass('disabled')
                  $('.guest-btn').prop('disabled', false)
                }
            }
        });


    },
    onStartEmptyLoyalty() {
        if($('#loyalty_card').val() === ''){
            // console.log('emptyyy')
        }
          var txt = $("#loyalty_card");
          var func = function() {
            txt.val(txt.val().replace(/\s/g, ''));
          }
          txt.keyup(func).blur(func);

    },
    postcodeFormatter() {
        function isValidPostcode(p) {
            return p.replace(/^(.*)(\d)/, "$1 $2").replace(/ +(?= )/g,'');
        }

        $(document.body).on('change', '#shipping_postcode', function(e){
            if($('#shipping_country').val() === 'GB'){
                $(this).val(isValidPostcode($(this).val()))
            }
        })
        $(document.body).on('change', '#billing_postcode', function(e){
            if($('#billing_country').val() === 'GB'){
                $(this).val(isValidPostcode($(this).val()))
            }
        })

        if($('#billing_postcode').length){
            if($('#billing_country').val() === 'GB'){
                $('#billing_postcode').val(isValidPostcode($('#billing_postcode').val()))
            }
        }
        if($('#shipping_postcode').length){
            if($('#shipping_country').val() === 'GB'){
                $('#shipping_postcode').val(isValidPostcode($('#shipping_postcode').val()))
            }
        }
    },
    checkoutStart() {
        const app = this
        if ( typeof appdata === 'undefined' ) {
            return false;
        }

        $.blockUI.defaults.overlayCSS.cursor = 'default';

        var wc_checkout_form = {
            updateTimer: false,
            dirtyInput: false,
            selectedPaymentMethod: false,
            xhr: false,
            $order_review: $( '#order_review' ),
            $checkout_form: $( 'form.checkout' ),
            init: function() {
                $( document.body ).bind( 'update_checkout', this.update_checkout );
                $( document.body ).bind( 'init_checkout', this.init_checkout );

                // Payment methods
                this.$checkout_form.on( 'click', 'input[name="payment_method"]', this.payment_method_selected );

                if ( $( document.body ).hasClass( 'woocommerce-order-pay' ) ) {
                    this.$order_review.on( 'click', 'input[name="payment_method"]', this.payment_method_selected );
                    this.$order_review.on( 'submit', this.submitOrder );
                    this.$order_review.attr( 'novalidate', 'novalidate' );
                }

                // Prevent HTML5 validation which can conflict.
                this.$checkout_form.attr( 'novalidate', 'novalidate' );

                // Form submission
                this.$checkout_form.on( 'submit', this.submit );

                // Inline validation
                this.$checkout_form.on( 'input validate change', '.input-text, select, input:checkbox', this.validate_field );

                // Manual trigger
                this.$checkout_form.on( 'update', this.trigger_update_checkout );

                // Inputs/selects which update totals
                this.$checkout_form.on( 'change', 'select.shipping_method, input[name^="shipping_method"], .update_totals_on_change select, .update_totals_on_change textarea, .update_totals_on_change input[type="radio"], .update_totals_on_change input[type="checkbox"]', this.trigger_update_checkout ); // eslint-disable-line max-len
                this.$checkout_form.on( 'change', '.address-field select', this.input_changed );
                this.$checkout_form.on( 'change', '.address-field input.input-text, .update_totals_on_change input.input-text', this.maybe_input_changed ); // eslint-disable-line max-len
                this.$checkout_form.on( 'keydown', '.address-field input.input-text, .update_totals_on_change input.input-text', this.queue_update_checkout ); // eslint-disable-line max-len



                // Trigger events
                this.init_payment_methods();

                // Update on page load

                $( document.body ).trigger( 'init_checkout' );


                if ( appdata.option_guest_checkout === 'yes' ) {
                    $( 'input#createaccount' ).change( this.toggle_create_account ).change();
                }
            },
            init_payment_methods: function() {
                var $payment_methods = $( '.checkout' ).find( 'input[name="payment_method"]' );

                // // If there is one method, we can hide the radio input
                // if ( 1 === $payment_methods.length ) {
                //     $payment_methods.eq(0).hide();
                // }

                // If there was a previously selected method, check that one.
                if ( wc_checkout_form.selectedPaymentMethod ) {
                    $( '#' + wc_checkout_form.selectedPaymentMethod ).prop( 'checked', true );
                }

                // If there are none selected, select the first.
                if ( 0 === $payment_methods.filter( ':checked' ).length ) {
                    $payment_methods.eq(0).prop( 'checked', true );
                }

                // Get name of new selected method.
                var checkedPaymentMethod = $payment_methods.filter( ':checked' ).eq(0).prop( 'id' );

                if ( $payment_methods.length > 1 ) {
                    // Hide open descriptions.
                    $( 'div.payment_box:not(".' + checkedPaymentMethod + '")' ).filter( ':visible' ).slideUp( 0 );
                }

                // Trigger click event for selected method
                $payment_methods.filter( ':checked' ).eq(0).trigger( 'click' );
            },
            get_payment_method: function() {
                return wc_checkout_form.$checkout_form.find( 'input[name="payment_method"]:checked' ).val();
            },
            payment_method_selected: function( e ) {
                e.stopPropagation();

                if ( $( '.payment_methods input.input-radio' ).length > 1 ) {
                    var target_payment_box = $( 'div.payment_box.' + $( this ).attr( 'ID' ) ),
                        is_checked         = $( this ).is( ':checked' );

                    if ( is_checked && ! target_payment_box.is( ':visible' ) ) {
                        $( 'div.payment_box' ).filter( ':visible' ).slideUp( 230 );

                        if ( is_checked ) {
                            target_payment_box.slideDown( 230 );
                        }
                    }
                } else {
                    $( 'div.payment_box' ).show();
                }
                if ( $( this ).data( 'order_button_text' ) ) {
                    $( '#place_order' ).text( $( this ).data( 'order_button_text' ) );
                } else {
                    $( '#place_order' ).text( $( '#place_order' ).data( 'value' ) );
                }

                var selectedPaymentMethod = $( '.checkout input[name="payment_method"]:checked' ).attr( 'id' );

                if ( selectedPaymentMethod !== wc_checkout_form.selectedPaymentMethod ) {
                    $( document.body ).trigger( 'payment_method_selected' );
                }

                wc_checkout_form.selectedPaymentMethod = selectedPaymentMethod;
            },
            toggle_create_account: function() {
                $( '.create-account' ).hide();

                if ( $( this ).is( ':checked' ) ) {
                    // Ensure password is not pre-populated.
                    $( '#account_password' ).val( '' ).change();
                    $( '.create-account' ).show();
                }
            },
            init_checkout: function() {
                $( document.body ).trigger( 'update_checkout' );
            },
            maybe_input_changed: function( e ) {
                if ( wc_checkout_form.dirtyInput ) {
                    wc_checkout_form.input_changed( e );
                }
            },
            input_changed: function( e ) {
                wc_checkout_form.dirtyInput = e.target;
                wc_checkout_form.maybe_update_checkout();
            },
            queue_update_checkout: function( e ) {
                var code = e.keyCode || e.which || 0;

                if ( code === 9 ) {
                    return true;
                }

                wc_checkout_form.dirtyInput = this;
                wc_checkout_form.reset_update_checkout_timer();
                wc_checkout_form.updateTimer = setTimeout( wc_checkout_form.maybe_update_checkout, '1000' );
            },
            trigger_update_checkout: function() {
                wc_checkout_form.reset_update_checkout_timer();
                wc_checkout_form.dirtyInput = false;
                $( document.body ).trigger( 'update_checkout' );
            },
            maybe_update_checkout: function() {
                var update_totals = true;

                if ( $( wc_checkout_form.dirtyInput ).length ) {
                    var $required_inputs = $( wc_checkout_form.dirtyInput ).closest( 'div' ).find( '.address-field.validate-required' );

                    if ( $required_inputs.length ) {
                        $required_inputs.each( function() {
                            if ( $( this ).find( 'input.input-text' ).val() === '' ) {
                                update_totals = false;
                            }
                        });
                    }
                }
                if ( update_totals ) {
                    wc_checkout_form.trigger_update_checkout();
                }
            },
            reset_update_checkout_timer: function() {
                clearTimeout( wc_checkout_form.updateTimer );
            },
            is_valid_json: function( raw_json ) {
                try {
                    var json = $.parseJSON( raw_json );

                    return ( json && 'object' === typeof json );
                } catch ( e ) {
                    return false;
                }
            },
            validate_field: function( e ) {
                var $this             = $( this ),
                    $parent           = $this.closest( '.input-wrapper' ),
                    validated         = true,
                    validate_required = $parent.is( '.validate-required' ),
                    validate_email    = $parent.is( '.validate-email' ),
                    event_type        = e.type;



                if ( 'input' === event_type ) {
                    $parent.removeClass( 'woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email woocommerce-validated' ); // eslint-disable-line max-len
                }

                if ( 'validate' === event_type || 'change' === event_type ) {


                    if ( validate_required ) {
                        if ( 'checkbox' === $this.attr( 'type' ) && ! $this.is( ':checked' ) ) {
                            $parent.removeClass( 'woocommerce-validated' ).addClass( 'woocommerce-invalid woocommerce-invalid-required-field' );
                            validated = false;
                        } else if ( $this.val() === '' ) {
                            $parent.removeClass( 'woocommerce-validated' ).addClass( 'woocommerce-invalid woocommerce-invalid-required-field' );
                            validated = false;
                        }
                    }

                    if ( validate_email ) {
                        if ( $this.val() ) {
                            /* eslint-disable */
                            /* https://stackoverflow.com/questions/2855865/jquery-validate-e-mail-address-regex */
                            var pattern = new RegExp(/^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[0-9a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i); // eslint-disable-line max-len
                            /* eslint-enable */

                            if ( ! pattern.test( $this.val()  ) ) {
                                $parent.removeClass( 'woocommerce-validated' ).addClass( 'woocommerce-invalid woocommerce-invalid-email' );
                                validated = false;
                                if($this.attr('name') == 'billing_email'){
                                  $('.guest-btn').addClass('disabled')
                                  $('.guest-btn').prop('disabled', 'disabled')
                                }
                            } else {
                                if($this.attr('name') == 'billing_email'){
                                  $('.guest-btn').removeClass('disabled')
                                  $('.guest-btn').prop('disabled', false)
                                }
                            }
                        } else {
                            if($this.attr('name') == 'billing_email'){
                              $('.guest-btn').addClass('disabled')
                              $('.guest-btn').prop('disabled', 'disabled')
                            }
                        }
                    }

                    if ( validated ) {
                        $parent.removeClass( 'woocommerce-invalid woocommerce-invalid-required-field woocommerce-invalid-email' ).addClass( 'woocommerce-validated' ); // eslint-disable-line max-len
                    }
                }
            },
            update_checkout: function( event, args ) {

                // Small timeout to prevent multiple requests when several fields update at the same time
                wc_checkout_form.reset_update_checkout_timer();
                wc_checkout_form.updateTimer = setTimeout( wc_checkout_form.update_checkout_action, '5', args );
            },
            update_checkout_action: function( args ) {
                if ( wc_checkout_form.xhr ) {
                    wc_checkout_form.xhr.abort();
                }

                if ( $( 'form.checkout' ).length === 0 ) {
                    return;
                }

                args = typeof args !== 'undefined' ? args : {
                    update_shipping_method: true,
                };

                var s_country        = $( '#shipping_country' ).val(),
                    s_state          = $( '#shipping_state' ).val(),
                    s_postcode       = $( ':input#shipping_postcode' ).val(),
                    s_city           = $( '#shipping_city' ).val(),
                    s_address        = $( ':input#shipping_address_1' ).val(),
                    s_address_2      = $( ':input#shipping_address_2' ).val(),
                    country          = s_country,
                    state            = s_state,
                    postcode         = s_postcode,
                    city             = s_city,
                    address          = s_address,
                    address_2        = s_address_2,
                    $required_inputs = $( wc_checkout_form.$checkout_form ).find( '.address-field.validate-required:visible' ),
                    has_full_address = true;

                if ( $required_inputs.length ) {
                    $required_inputs.each( function() {
                        if ( $( this ).find( ':input' ).val() === '' ) {
                            has_full_address = false;
                        }
                    });
                }

                // if ( !$( '#bill_to_same_address' ).is( ':checked' ) ) {
                //     country        = $( '#billing_country' ).val();
                //     state          = $( '#billing_state' ).val();
                //     postcode       = $( ':input#billing_postcode' ).val();
                //     city           = $( '#billing_city' ).val();
                //     address        = $( ':input#billing_address_1' ).val();
                //     address_2      = $( ':input#billing_address_2' ).val();
                // }
                // else {
                //     $( '#billing_country' ).val(s_country)
                //     $( '#billing_state' ).val(s_state);
                //     $( ':input#billing_postcode' ).val(s_postcode);
                //     $( '#billing_city' ).val(s_city);
                //     $( ':input#billing_address_1' ).val(s_address);
                //     $( ':input#billing_address_2' ).val(s_address_2);
                //     $( ':input#billing_first_name' ).val($('#shipping_first_name').val());
                //     $( ':input#billing_last_name' ).val($('#shipping_last_name').val());

                // }

                var dataForm = {
                    security        : appdata.update_order_review_nonce,
                    payment_method  : wc_checkout_form.get_payment_method(),
                    country         : country,
                    state           : state,
                    postcode        : postcode,
                    city            : city,
                    address         : address,
                    address_2       : address_2,
                    s_country       : s_country,
                    s_state         : s_state,
                    s_postcode      : s_postcode,
                    s_city          : s_city,
                    s_address       : s_address,
                    s_address_2     : s_address_2,
                    has_full_address: has_full_address,
                    post_data       : $( 'form.checkout' ).serialize(),
                };

                if ( false !== args.update_shipping_method ) {
                    var shipping_methods = {};


                    // eslint-disable-next-line max-len
                    $( 'select.shipping_method, input[name^="shipping_method"][type="radio"]:checked, input[name^="shipping_method"][type="hidden"]' ).each( function() {
                        shipping_methods[ $( this ).data( 'index' ) ] = $( this ).val();
                    } );

                    dataForm.shipping_method = shipping_methods;

                }
                if(dataForm.shipping_method[0]){
                    $('.shipping-calendar-container-custom').show()
                } else {
                    $('.shipping-calendar-container-custom').hide()
                }

                // if(dataForm.shipping_method[0] && dataForm.shipping_method[0].includes('local_pickup')){
                //         dataForm.s_country = '';
                //         dataForm.s_state = '';
                //         dataForm.s_postcode = '';
                //         dataForm.s_city = '';
                //         dataForm.s_address = '';
                //         dataForm.s_address_2 = '';
                // }

                $( '.review-order' ).block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6,
                    },
                });
                $( '.step-app' ).block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0.6,
                    },
                });
                // console.log(dataForm)
                wc_checkout_form.xhr = $.ajax({
                    type:       'POST',
                    url:        appdata.wc_ajax_url.toString().replace( '%%endpoint%%', 'update_order_review' ),
                    data:       dataForm,
                    success:    function( data ) {
                        // Reload the page if requested
                        if ( data && true === data.reload ) {
                            window.location.reload();
                            return;
                        }

                        // Remove any notices added previously
                        $( '.shop-error-checkout' ).remove();

                        var termsCheckBoxChecked = $( '#terms' ).prop( 'checked' );

                        // Save payment details to a temporary object
                        var paymentDetails = {};
                        $( '.payment_box :input' ).each( function() {
                            var ID = $( this ).attr( 'id' );

                            if ( ID ) {
                                if ( $.inArray( $( this ).attr( 'type' ), [ 'checkbox', 'radio' ] ) !== -1 ) {
                                    paymentDetails[ ID ] = $( this ).prop( 'checked' );
                                } else {
                                    paymentDetails[ ID ] = $( this ).val();
                                }
                            }
                        });




                        // Always update the fragments
                        if ( data && data.fragments ) {
                            $.each( data.fragments, function ( key, value ) {
                                if ( ! wc_checkout_form.fragments || wc_checkout_form.fragments[ key ] !== value ) {
                                    $( key ).replaceWith( value );
                                }

                            });
                            $( '.review-order' ).unblock()
                            $( '.step-app' ).unblock()



                            wc_checkout_form.fragments = data.fragments;
                        }

                       if($('.step-steps').find('.active').attr('data-step-target') === 'shipping'){
                            // console.log(dataForm.shipping_method)

                            // if(dataForm.shipping_method[0] && !dataForm.shipping_method[0].includes('local_pickup')){
                               // let allValidated = true;
                               // $('.woocommerce-shipping-fields__field-wrapper .validate-required').each(function(){
                               //      if(!$(this).find('input, select, textarea').val() || $(this).find('input, select, textarea').val() == ''){
                               //          allValidated = false
                               //      }
                               // })
                               // if(allValidated){
                               //      $('.shipping-btn').prop('disabled', false)
                               //      $('.shipping-btn').removeClass('disabled')
                               // } else {
                               //      $('.shipping-btn').prop('disabled', true)
                               //      $('.shipping-btn').addClass('disabled')
                               // }
                            // } else {
                            //         $('.shipping-btn').prop('disabled', false)
                            //         $('.shipping-btn').removeClass('disabled')
                            // }

                            if(Object.keys(dataForm.shipping_method).length === 1 && dataForm.shipping_method[0].includes('local_pickup')){
                                    $('.shipping-btn').prop('disabled', false)
                                    $('.shipping-btn').removeClass('disabled')
                            } else {
                               let allValidated = true;
                               $('.woocommerce-shipping-fields__field-wrapper .validate-required').each(function(){
                                    if(!$(this).find('input, select, textarea').val() || $(this).find('input, select, textarea').val() == ''){
                                        allValidated = false
                                    }
                               })
                               if(allValidated){
                                    $('.shipping-btn').prop('disabled', false)
                                    $('.shipping-btn').removeClass('disabled')
                               } else {
                                    $('.shipping-btn').prop('disabled', true)
                                    $('.shipping-btn').addClass('disabled')
                               }
                            }

                        }


                        const allmethods = []
                        $('.woocommerce-shipping-methods input').each(function(){
                            allmethods.push($( this ).val())
                        })

                        $( 'select.shipping_method, input[name^="shipping_method"][type="radio"]:checked, input[name^="shipping_method"][type="hidden"]' ).each( function() {
                            const str = $( this ).val();

                            if($('label[for="'+ $(this).attr('id') +'"').text().toLowerCase().includes("standard delivery") ){
                                $('.orddd_text_block').show()
                            } else {
                                $('.orddd_text_block').hide()
                            }
                        });

                        // Recheck the terms and conditions box, if needed
                        if ( termsCheckBoxChecked ) {
                            $( '#terms' ).prop( 'checked', true );
                        }



                        // Fill in the payment details if possible without overwriting data if set.
                        if ( ! $.isEmptyObject( paymentDetails ) ) {
                            $( '.payment_box :input' ).each( function() {
                                var ID = $( this ).attr( 'id' );
                                if ( ID ) {
                                    if ( $.inArray( $( this ).attr( 'type' ), [ 'checkbox', 'radio' ] ) !== -1 ) {
                                        $( this ).prop( 'checked', paymentDetails[ ID ] ).change();
                                    } else if ( $.inArray( $( this ).attr( 'type' ), [ 'select' ] ) !== -1 ) {
                                        $( this ).val( paymentDetails[ ID ] ).change();
                                    } else if ( null !== $( this ).val() && 0 === $( this ).val().length ) {
                                        $( this ).val( paymentDetails[ ID ] ).change();
                                    }
                                }
                            });
                        }

                        // Check for error
                        if ( data && 'failure' === data.result ) {

                            var $form = $( 'form.checkout' );

                            // Remove notices from all sources
                            $( '.shop-error, .shop-message' ).remove();

                            // Add new errors returned by this event
                            if ( data.messages ) {
                                $('.checkout-notices-custom').before( '<div class="shop-error-checkout">' + data.messages + '</div>' ); // eslint-disable-line max-len
                            } else {
                                $('.checkout-notices-custom').before( data );
                            }

                            // Lose focus for all fields
                            $form.find( '.input-text, select, input:checkbox' ).trigger( 'validate' ).blur();

                            wc_checkout_form.scroll_to_notices();
                        }

                        // Re-init methods
                        wc_checkout_form.init_payment_methods();
                        // app.stepsLoad()

                        // Fire updated_checkout event.
                        $( document.body ).trigger( 'updated_checkout', [ data ] )
                    },

                });
            },
            handleUnloadEvent: function( e ) {
                // Modern browsers have their own standard generic messages that they will display.
                // Confirm, alert, prompt or custom message are not allowed during the unload event
                // Browsers will display their own standard messages

                // Check if the browser is Internet Explorer
                if((navigator.userAgent.indexOf('MSIE') !== -1 ) || (!!document.documentMode)) {
                    // IE handles unload events differently than modern browsers
                    e.preventDefault();
                    return undefined;
                }

                return true;
            },
            attachUnloadEventsOnSubmit: function() {
                $( window ).on('beforeunload', this.handleUnloadEvent);
            },
            detachUnloadEventsOnSubmit: function() {
                $( window ).unbind('beforeunload', this.handleUnloadEvent);
            },
            blockOnSubmit: function( $form ) {
                var form_data = $form.data();

                if ( 1 !== form_data['blockUI.isBlocked'] ) {
                    $form.block({
                        message: null,
                        overlayCSS: {
                            background: '#fff',
                            opacity: 0.6,
                        },
                    });
                }
            },
            submitOrder: function() {
                wc_checkout_form.blockOnSubmit( $( this ) );
            },
            submit: function() {
                wc_checkout_form.reset_update_checkout_timer();
                var $form = $( this );

                if ( $form.is( '.processing' ) ) {
                    return false;
                }

                // Trigger a handler to let gateways manipulate the checkout if needed
                // eslint-disable-next-line max-len
                if ( $form.triggerHandler( 'checkout_place_order' ) !== false && $form.triggerHandler( 'checkout_place_order_' + wc_checkout_form.get_payment_method() ) !== false ) {

                    $form.addClass( 'processing' );

                    wc_checkout_form.blockOnSubmit( $form );

                    // Attach event to block reloading the page when the form has been submitted
                    wc_checkout_form.attachUnloadEventsOnSubmit();

                    // ajaxSetup is global, but we use it to ensure JSON is valid once returned.
                    $.ajaxSetup( {
                        dataFilter: function( raw_response, dataType ) {
                            // We only want to work with JSON
                            if ( 'json' !== dataType ) {
                                return raw_response;
                            }

                            if ( wc_checkout_form.is_valid_json( raw_response ) ) {
                                return raw_response;
                            } else {
                                // Attempt to fix the malformed JSON
                                var maybe_valid_json = raw_response.match( /{"result.*}/ );

                                if ( null === maybe_valid_json ) {
                                    console.log( 'Unable to fix malformed JSON' );
                                } else if ( wc_checkout_form.is_valid_json( maybe_valid_json[0] ) ) {
                                    console.log( 'Fixed malformed JSON. Original:' );
                                    console.log( raw_response );
                                    raw_response = maybe_valid_json[0];
                                } else {
                                    console.log( 'Unable to fix malformed JSON' );
                                }
                            }

                            return raw_response;
                        },
                    } );
                    // console.log($form.serialize());
                    $.ajax({
                        type:       'POST',
                        url:        appdata.checkout_url,
                        data:       $form.serialize(),
                        dataType:   'json',
                        success:    function( result ) {
                            // Detach the unload handler that prevents a reload / redirect
                            wc_checkout_form.detachUnloadEventsOnSubmit();
                            try {
                                if ( 'success' === result.result && $form.triggerHandler( 'checkout_place_order_success' ) !== false ) {
                                    if ( -1 === result.redirect.indexOf( 'https://' ) || -1 === result.redirect.indexOf( 'http://' ) ) {
                                        window.location = result.redirect;
                                    } else {
                                        window.location = decodeURI( result.redirect );
                                    }
                                } else if ( 'failure' === result.result ) {
                                    // console.log(result)
                                    throw 'Result failure';
                                } else {
                                    throw 'Invalid response';
                                }
                            } catch( err ) {
                                    console.log(err)

                                // Reload page
                                if ( true === result.reload ) {
                                    window.location.reload();
                                    return;
                                }

                                // Trigger update in case we need a fresh nonce
                                if ( true === result.refresh ) {
                                    $( document.body ).trigger( 'update_checkout' );
                                }

                                // Add new errors
                                if ( result.messages ) {

                                    console.log(err)

                                    wc_checkout_form.submit_error( result.messages );
                                } else {
                                    console.log(err)

                                    wc_checkout_form.submit_error( '<div class="shop-error">' + appdata.i18n_checkout_error + '</div>' ); // eslint-disable-line max-len
                                }
                            }
                        },
                        error:  function( jqXHR, textStatus, errorThrown ) {
                            console.log(jqXHR)
                            console.log(textStatus)
                            // Detach the unload handler that prevents a reload / redirect
                            wc_checkout_form.detachUnloadEventsOnSubmit();

                            wc_checkout_form.submit_error( '<div class="shop-error">' + errorThrown + '</div>' );
                        },
                    });
                }

                return false;
            },
            submit_error: function( error_message ) {

                $( '.shop-error-checkout, .shop-error, .shop-message' ).remove();
                $('.checkout-notices-custom').before( '<div class="shop-error-checkout">' + error_message + '</div>' ); // eslint-disable-line max-len
                wc_checkout_form.$checkout_form.removeClass( 'processing' ).unblock();
                wc_checkout_form.$checkout_form.find( '.input-text, select, input:checkbox' ).trigger( 'validate' ).blur();
                wc_checkout_form.scroll_to_notices();
                $( document.body ).trigger( 'checkout_error' );
            },
            scroll_to_notices: function() {
                var scrollElement           = $( '.shop-error-checkout' );

                if ( ! scrollElement.length ) {
                    scrollElement = $( '.form.checkout' );
                }
                $('html, body').animate({
                    scrollTop: scrollElement.offset().top,
                }, 400);
            },
        };

        var wc_checkout_coupons = {
            init: function() {
                $( document.body ).on( 'click', '.woocommerce-remove-coupon', this.remove_coupon );
                $( document.body ).on( 'click', '.apply-coupon', this.submit );
            },
            submit: function() {
                var $form = $( '.form-coupon' );

                if ( $form.is( '.processing' ) ) {
                    return false;
                }

                $form.addClass( 'processing' )
                $('.review-order').block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0,
                    },
                })

                var data = {
                    security:       appdata.apply_coupon_nonce,
                    coupon_code:    $form.find( 'input[name="coupon_code"]' ).val(),
                };

                $.ajax({
                    type:       'POST',
                    url:        appdata.wc_ajax_url.toString().replace( '%%endpoint%%', 'apply_coupon' ),
                    data:       data,
                    success:    function( code ) {

                        $( '.shop-error, .shop-message, .shop-notice' ).remove();
                        $form.removeClass( 'processing' );
                        $('.review-order').unblock();
                        $('[data-step-target="shipping"]').click()
                        if ( code ) {
                            $form.append( code );

                            $( document.body ).trigger( 'applied_coupon_in_checkout', [ data.coupon_code ] );
                            $( document.body ).trigger( 'update_checkout', { update_shipping_method: true } );
                        }
                    },
                    dataType: 'html',
                });

                return false;
            },
            remove_coupon: function( e ) {
                e.preventDefault();

                var container = $( this ).parents( '.review-order' ),
                    coupon    = $( this ).data( 'coupon' );

                container.addClass( 'processing' ).block({
                    message: null,
                    overlayCSS: {
                        background: '#fff',
                        opacity: 0,
                    },
                });

                var data = {
                    security: appdata.remove_coupon_nonce,
                    coupon:   coupon,
                };

                $.ajax({
                    type:    'POST',
                    url:     appdata.wc_ajax_url.toString().replace( '%%endpoint%%', 'remove_coupon' ),
                    data:    data,
                    success: function( code ) {
                        $( '.shop-error, .shop-message, .shop-notice' ).remove();
                        container.removeClass( 'processing' ).unblock();

                        if ( code ) {
                            $( '.form-coupon' ).append( code );

                            $( document.body ).trigger( 'update_checkout', { update_shipping_method: false } );

                            // Remove coupon code from coupon field
                            $( 'form.checkout_coupon' ).find( 'input[name="coupon_code"]' ).val( '' );
                        }
                    },
                    error: function ( jqXHR ) {
                        // if ( appdata.debug_mode ) {
                            /* jshint devel: true */
                            console.log( jqXHR.responseText );
                        // }
                    },
                    dataType: 'html',
                });
            },
        };

        var wc_billing_toggle = {
            init: function() {
                $( document.body ).on( 'change', '#bill_to_same_address', this.toggle_billing );
            },

            toggle_billing: function() {
                if ( $( '#bill_to_same_address' ).is( ':checked' ) ) {
                    $( '.woocommerce-billing-fields' ).slideUp();
                }
                else {
                    $( '.woocommerce-billing-fields' ).slideDown();

                    $( '#billing_country' ).val('')
                    $( '#billing_state' ).val('');
                    $( ':input#billing_postcode' ).val('');
                    $( '#billing_city' ).val('');
                    $( ':input#billing_address_1' ).val('');
                    $( ':input#billing_address_2' ).val('');
                    $( ':input#billing_first_name' ).val('');
                    $( ':input#billing_last_name' ).val('');
                }

            },
        };
        var wc_terms_toggle = {
            init: function() {
                $( document.body ).on( 'click', 'a.woocommerce-terms-and-conditions-link', this.toggle_terms );
            },

            toggle_terms: function() {
                if ( $( '.woocommerce-terms-and-conditions' ).length ) {
                    $( '.woocommerce-terms-and-conditions' ).slideToggle( function() {
                        var link_toggle = $( '.woocommerce-terms-and-conditions-link' );

                        if ( $( '.woocommerce-terms-and-conditions' ).is( ':visible' ) ) {
                            link_toggle.addClass( 'woocommerce-terms-and-conditions-link--open' );
                            link_toggle.removeClass( 'woocommerce-terms-and-conditions-link--closed' );
                        } else {
                            link_toggle.removeClass( 'woocommerce-terms-and-conditions-link--open' );
                            link_toggle.addClass( 'woocommerce-terms-and-conditions-link--closed' );
                        }
                    } );

                    return false;
                }
            },
        };

        wc_checkout_form.init();
        wc_checkout_coupons.init();
        wc_terms_toggle.init();
        wc_billing_toggle.init();
    },
    init(){
        this.checkoutStart()
        this.modalLogin()
        this.postcodeFormatter()
        this.stepsLoad()
    },
    finalize() {
        this.onStartEmptyLoyalty()
    }
}
